import { ObjectTypeMarker } from '@cas/assets/images/object-types/map-markers';
import { Icon } from 'leaflet';
import { useMemo } from 'react';
import { getObjectTypeIcon, getSvgDimensions } from './icons';
import { ObjectType } from '@dmc/ui';

interface ObjectTypeMarkerIconReturn {
  width: number;
  height: number;
  icon: Icon;
}

export const useObjectTypeMarkerIcon = (obj: ObjectType): ObjectTypeMarkerIconReturn => {
  return useMemo<ObjectTypeMarkerIconReturn>(() => {
    const svgString = ObjectTypeMarker[obj];
    // Fixme: Attempting to get dimensions from an SVG string is not an effective approach.
    const { width, height } = getSvgDimensions(svgString) || { width: 32, height: 32 };
    const isSvgObjectTypeIcon = obj !== ObjectType.Unknown;
    const icon = getObjectTypeIcon(svgString, width, height, isSvgObjectTypeIcon);
    return { width, height, icon };
  }, [obj]);
};
